var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_c('ProtalHeader'),_c('div',{staticClass:"main-containet"},[_c('router-view')],1),_c('ProtalFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }